"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PSCAddress$ = exports.PSCAddress$outboundSchema = exports.PSCAddress$inboundSchema = void 0;
exports.pscAddressToJSON = pscAddressToJSON;
exports.pscAddressFromJSON = pscAddressFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const pscaddressparts_js_1 = require("./pscaddressparts.js");
const pscsinglelineaddress_js_1 = require("./pscsinglelineaddress.js");
/** @internal */
exports.PSCAddress$inboundSchema = z.object({
    address_parts: z.nullable(pscaddressparts_js_1.PSCAddressParts$inboundSchema),
    single_line_address: pscsinglelineaddress_js_1.PSCSingleLineAddress$inboundSchema,
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "address_parts": "addressParts",
        "single_line_address": "singleLineAddress",
    });
});
/** @internal */
exports.PSCAddress$outboundSchema = z.object({
    addressParts: z.nullable(pscaddressparts_js_1.PSCAddressParts$outboundSchema),
    singleLineAddress: pscsinglelineaddress_js_1.PSCSingleLineAddress$outboundSchema,
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        addressParts: "address_parts",
        singleLineAddress: "single_line_address",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PSCAddress$;
(function (PSCAddress$) {
    /** @deprecated use `PSCAddress$inboundSchema` instead. */
    PSCAddress$.inboundSchema = exports.PSCAddress$inboundSchema;
    /** @deprecated use `PSCAddress$outboundSchema` instead. */
    PSCAddress$.outboundSchema = exports.PSCAddress$outboundSchema;
})(PSCAddress$ || (exports.PSCAddress$ = PSCAddress$ = {}));
function pscAddressToJSON(pscAddress) {
    return JSON.stringify(exports.PSCAddress$outboundSchema.parse(pscAddress));
}
function pscAddressFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PSCAddress$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PSCAddress' from JSON`);
}
//# sourceMappingURL=pscaddress.js.map